var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_1281_370)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6812 13.8094L31.3968 35.4187C31.3968 35.4187 30.7968 36.9187 29.1468 36.1969L19.2562 28.6125L15.6562 26.8781L9.59997 24.8437C9.59997 24.8437 8.67185 24.5156 8.5781 23.7937C8.48435 23.0719 9.6281 22.6875 9.6281 22.6875L33.7031 13.2469C33.7031 13.2375 35.6812 12.3656 35.6812 13.8094Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4875 35.175C18.4875 35.175 18.1969 35.1468 17.8406 34.0125C17.4844 32.8781 15.6562 26.8781 15.6562 26.8781L30.1969 17.6437C30.1969 17.6437 31.0406 17.1375 31.0031 17.6437C31.0031 17.6437 31.1531 17.7375 30.7031 18.15C30.2531 18.5718 19.2844 28.4343 19.2844 28.4343",
    fill: "#D2E4F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0437 31.5188L19.1343 35.0906C19.1343 35.0906 18.825 35.325 18.4968 35.175L19.2468 28.5469",
    fill: "#B5CFE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1281_370",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 47.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BCE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22A6DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a7a13e8ce5b4c49f77361fe27b5cd07f.svg";
export { ForwardRef as ReactComponent };